module.exports = __webpack_public_path__ + "img/logo-support.85f1b2ef.svg";